import React, { useState } from 'react'
import { Input, Modal, Typography } from 'antd'
import { Participant } from '../../list/types'

const { Text } = Typography

type Props = {
  open: boolean
  participant: Participant | null
  loading: boolean
  onClose: () => void
  onSubmit: (banReason: string) => void
}

export const UnbanModal: React.FC<Props> = ({
  open,
  participant,
  loading,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState('')

  const handleCancel = () => {
    setReason('')
    onClose()
  }

  return (
    <Modal
      title="Unban participant"
      open={open}
      onCancel={handleCancel}
      onOk={() => onSubmit(reason)}
      okText="Unban"
      cancelText="Cancel"
      okButtonProps={{ loading }}
      afterClose={() => setReason('')}
      destroyOnHidden
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Participant:{' '}
        <strong>
          {participant?.client.fullName || participant?.client.clientId}
        </strong>
      </Text>
      <Input.TextArea
        placeholder="Unban reason (optional)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        autoFocus
      />
    </Modal>
  )
}
